@let apiResponse = data();
@if (apiResponse) {
  <p-table
    [value]="apiResponse.data"
    [loading]="opkraevningService.datasource.isLoading()"
    [showGridlines]="true"
    [scrollable]="true"
    scrollHeight="flex"
    stripedRows
    class="p-datatable-sm lp-table"
    selectionMode="single"
    [metaKeySelection]="true"
    (onRowSelect)="onRowSelect($event)"
    dataKey="id"
    [lazy]="true"
    [lazyLoadOnInit]="false"
    (onLazyLoad)="onLazyLoad($event)"
    sortField="opkraevning.id"
    [sortOrder]="1"
    [paginator]="true"
    [rows]="100"
    [totalRecords]="apiResponse.totalRowCount"
    [showJumpToPageDropdown]="true"
    letKeepScrollPosition>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="opkraevning.godkendt" style="width: 120px">
          Godkendt
          <p-sortIcon field="opkraevning.godkendt" />
        </th>
        <th pSortableColumn="opkraevning.indbetalingsReference">
          Indbetalings ID
          <p-sortIcon field="opkraevning.indbetalingsReference" />
        </th>
        <th
          pSortableColumn="debiteringskonto.regNr, debiteringskonto.kontoNummer ">
          Betalingskonto
          <p-sortIcon
            field="debiteringskonto.regNr, debiteringskonto.kontoNummer" />
        </th>
        <th pSortableColumn="opkraevning.opkraevningsBeloeb">
          Beløb
          <p-sortIcon field="opkraevning.opkraevningsBeloeb" />
        </th>
        <th pSortableColumn="opkraevning.indlaesningStatus">
          Status
          <p-sortIcon field="opkraevning.indlaesningStatus" />
        </th>
        <th pSortableColumn="letsikring.letsikringNr">
          Letsikring nr
          <p-sortIcon field="letsikring.letsikringNr" />
        </th>
      </tr>
    </ng-template>
    <ng-template [appTableRow]="apiResponse.data" pTemplate="body" let-item>
      <tr [pSelectableRow]="item" class="cursor-pointer">
        <td class="!text-center">
          @if (item.godkendt) {
            <i class="pi pi-check"></i>
          }
        </td>
        <td>{{ item.indbetalingsReference }}</td>
        <td>
          @if (item.debiteringskonto) {
            {{ item.debiteringskonto.regNr }}
            {{ item.debiteringskonto.kontoNummer }}
            @if (item.debiteringskonto.navn) {
              ({{ item.debiteringskonto.navn }})
            }
          }
        </td>
        <td>{{ item.opkraevningsBeloeb | number: '1.2' }}</td>
        <td>{{ item.indlaesningStatus | translate }}</td>
        <td>{{ item.letsikringNr }}</td>
      </tr>
    </ng-template>
  </p-table>
}
